import { useFormik } from 'formik'
import { FC } from 'react'
import { Button, FormInput, useModal } from '../../../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { exameSchema } from '../../validation/exameSchema'
import { updateExame } from '../../core/_requests'
import { CustomOption, ExameDtoCadastro } from '../../core/_model'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  onConfirm: (item: CustomOption) => void
  item?: CustomOption
}

export const ExameModal: FC<IProps> = ({ onConfirm, item }) => {
  const { closeModal } = useModal()
  const { t } = useT()
  const id = item?.value ? Number(item.value) : undefined
  const isPersisted = !!id

  const initialValues = {
    exame: item?.label || '',
    descricao: item?.descricao || '',
  }

  const formik = useFormik({
    initialValues,
    validationSchema: exameSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        let result: CustomOption

        if (isPersisted && id) {
          const data: ExameDtoCadastro = {
            nome: values.exame,
            codigo: item?.codigo,
            tipo: item?.tipo,
            descricao: values.descricao || undefined,
            apac: item?.apac,
            ativo: item?.ativo ?? true,
          }

          const updated = await updateExame(id, data)

          result = {
            value: updated.id,
            label: updated.nome || values.exame,
            codigo: updated.codigo,
            tipo: updated.tipo,
            descricao: updated.descricao,
            apac: updated.apac,
          }

          await showAlert({
            title: t('common.success'),
            text: t('alert.atualizar', {
              gender: t('exame.gender'),
              name: t('exame.label'),
            }),
            icon: 'success',
          })
        } else {
          result = {
            label: values.exame,
            descricao: values.descricao || undefined,
            value: null,
          }
        }

        onConfirm(result)
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormInput
        formik={formik}
        name='exame'
        placeholder='Digite o nome do exame'
        label='Exame'
        isRequired={true}
        className='mb-3'
      />

      <div className='d-flex justify-content-end mt-5'>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {isPersisted ? t('common.save') : t('common.create')}
        </Button>
      </div>
    </form>
  )
}
